import { useEffect, useState } from 'react';
import md5 from 'md5';
import { adminApi } from '../api/adminApi';
import { setCookie } from '../dwi-functions';
import { Brand } from '../components/PortalShell';
import { IDENTITY_APPLICATION_ID } from '../config/identity';
import { clearIdentityStorage } from '../auth/AuthContext';

const safeRedirect = (candidate, fallback) => {
  if (!candidate) return fallback;
  try {
    const target = new URL(candidate, window.location.origin);
    if (target.protocol === 'https:' && (target.hostname === 'digitalwerks.com' || target.hostname.endsWith('.digitalwerks.com'))) return target.href;
  } catch (_) { /* fall through */ }
  return fallback;
};

const SuccessPage = () => {
  const [params] = useState(() => new URLSearchParams(window.location.search));
  const [error, setError] = useState('');
  const [applicationDenied, setApplicationDenied] = useState(false);

  useEffect(() => {
    const exchange = async () => {
      const idToken = params.get('idt');
      if (!idToken) { setError('This authentication link is incomplete. Return to sign in and try again.'); return; }
      try {
        window.history.replaceState({}, document.title, '/success');
        const result = await adminApi.exchange({
          idToken,
          applicationId: params.get('appid') || IDENTITY_APPLICATION_ID,
        });
        const user = result.data?.actor || {};
        const handoff = user.handoff && typeof user.handoff === 'object' ? user.handoff : {};
        const access = Number(user.admin?.access ?? user.accessLevel ?? 0);
        const profile = { user: { name: user.name, email: user.email, image: user.avatar?.url || `https://www.gravatar.com/avatar/${md5(String(user.email || '').toLowerCase())}?d=mp` } };
        const handoffSettings = { applicationIds: Array.isArray(handoff.applicationIds) ? handoff.applicationIds : [] };

        // Keep the established application handoff contract only after the server has
        // verified the Google ID token and created its authoritative HttpOnly session.
        if (user.userid || user.id) {
          const uid = user.userid || user.id;
          localStorage.setItem('_au', uid);
          localStorage.setItem('_auta', String(access));
          localStorage.setItem('_auta_s', JSON.stringify(handoffSettings));
          localStorage.setItem('lwp', JSON.stringify({ email: user.email, name: user.name }));
          setCookie('_aup', JSON.stringify(profile), 7);
          setCookie('_au', uid, 7);
          setCookie('_auta', access, 7);
          setCookie('_auta_s', JSON.stringify(handoffSettings), 7);
        }

        const requested = handoff.redirect;
        const fallback = access >= 10 ? `${window.location.origin}/admin/users` : `${window.location.origin}/access-denied`;
        window.location.replace(safeRedirect(requested, fallback));
      } catch (sessionError) {
        clearIdentityStorage();
        const denied = sessionError.details?.error?.code === 'application_not_allowed';
        setApplicationDenied(denied);
        setError(denied ? 'Contact your administrator to request access.' : sessionError.message || 'Authentication could not be completed.');
      }
    };
    exchange();
  }, [params]);

  return <main className="centered-page"><div className="callback-card"><Brand />{!error && <span className="spinner" aria-hidden="true" />}<h1>{applicationDenied ? 'Application not allowed' : error ? 'Sign-in could not be completed' : 'Verifying your identity'}</h1><p role={error ? 'alert' : 'status'}>{error || 'Your secure session is being prepared.'}</p>{error && <a className="button button--primary" href="/">{applicationDenied ? 'Return to sign in' : 'Try again'}</a>}</div></main>;
};

export default SuccessPage;
